import React, { useState, useEffect, useRef, useCallback } from 'react';

import '../index.scss';
import iconAccessibility from '../../../assets/images/accessibility.svg';

export default function Acessibilidade(props) {
  const { fontSizeAccessibility, setFontSizeAccess } = props;

  const [visible, setVisible] = useState(false);

  const buttonRef = useRef(null);
  const accessibilityRef = useRef(null);

  const handleClickOutside = useCallback((event) => {
    if (
      accessibilityRef.current &&
      !accessibilityRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setVisible(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    window.addEventListener('mouseup', handleClickOutside);

    return () => {
      window.removeEventListener('click', handleClickOutside);
      window.removeEventListener('mouseup', handleClickOutside);
    };
  });

  return (
    <>
      <div className="container-header-accessibility">
        <div onClick={() => setVisible(!visible)} ref={buttonRef}>
          <img
            src={iconAccessibility}
            style={{ backgroundColor: visible ? '#1384FB' : '' }}
            alt="Ícone de Acessibilidade"
          />
        </div>
        {visible && (
          <div className="container-accessibility" ref={accessibilityRef}>
            <div className="container-font-size-accessibility">
              <h3>Acessibilidade</h3>
              <h4>Tamanho de fonte</h4>
              <div>
                <input
                  type="radio"
                  checked={fontSizeAccessibility === 15}
                  onClick={() => setFontSizeAccess(15)}
                />
                <p>100% -</p>
                <span className="font-size15">Exemplo</span>
              </div>
              <div>
                <input
                  type="radio"
                  checked={fontSizeAccessibility === 22}
                  onClick={() => setFontSizeAccess(22)}
                />
                <p>150% -</p>
                <span className="font-size22">Exemplo</span>
              </div>
              <div>
                <input
                  type="radio"
                  checked={fontSizeAccessibility === 30}
                  onClick={() => setFontSizeAccess(30)}
                />
                <p>200% -</p>
                <span className="font-size30">Exemplo</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
